import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  to?: string;
  linkText?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  to,
  linkText,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between mb-6 md:mb-8">
      <div>
        <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-[0.2em] text-accent-700 uppercase">
          <span className="w-6 h-px bg-accent-500" aria-hidden="true" />
          {eyebrow}
        </span>
        <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mt-2">
          {title}
        </h2>
        {desc ? (
          <p className="text-sm text-foreground-600 mt-2 max-w-2xl leading-relaxed">{desc}</p>
        ) : null}
      </div>
      {to && linkText ? (
        <Link
          to={to}
          className="group inline-flex items-center gap-1.5 text-sm font-bold text-foreground-900 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer shrink-0"
        >
          {linkText}
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1" />
        </Link>
      ) : null}
    </div>
  );
}